var _defs, _path, _path2, _rect, _line, _line2, _line3, _line4, _polygon, _polygon2, _polygon3, _polygon4, _path3, _line5, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiBasic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.9029,
    height: 64.9106,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.9029 64.9106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    "data-name": "Unbenannter Verlauf 2",
    x1: 4994.3992,
    y1: 63.7723,
    x2: 4994.3992,
    y2: 0,
    gradientTransform: "translate(5034.2054) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7edef",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abdfed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,39.8063c0,9.0301,2.953,17.2871,8.0191,23.966h63.573c5.0671-6.6789,8.0202-14.9359,8.0202-23.966C79.6123,17.8219,61.7904,0,39.8058,0,17.8214,0,0,17.8219,0,39.8063",
    fill: "url(#Unbenannter_Verlauf_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6556,63.7723h64.2013V6.607H7.6556v57.1653Z",
    fill: "#fc0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7677,
    y: 27.6241,
    width: 37.9751,
    height: 36.1482,
    fill: "#d5eef9",
    stroke: "#53514f",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.7562,
    y1: 27.6241,
    x2: 39.7562,
    y2: 63.7723,
    fill: "none",
    stroke: "#53514f",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 59.196,
    y1: 27.6241,
    x2: 20.2996,
    y2: 27.6241,
    fill: "none",
    stroke: "#53514f",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 58.7428,
    y1: 27.6241,
    x2: 58.7428,
    y2: 63.7723,
    fill: "none",
    stroke: "#53514f",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7677,
    y1: 27.6241,
    x2: 20.7677,
    y2: 63.7723,
    fill: "none",
    stroke: "#53514f",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.6999 21.3482 38.3712 21.3482 40.0577 19.6445 38.3864 19.6445 36.6999 21.3482"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.1352 19.6445 34.4468 21.3482 36.1161 21.3482 37.8065 19.6445 36.1352 19.6445"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "40.4469 19.6445 42.1353 21.3482 43.8046 21.3482 42.12 19.6445 40.4469 19.6445"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.7019 19.6445 44.3903 21.3482 46.0635 21.3482 44.3732 19.6445 42.7019 19.6445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1244,19.3366c3.8748,0,6.4847-3.0399,6.7213-6.5152l-2.9648-.7366c-.0515.9613-.2308,1.9116-.5323,2.826.0038-.4691-.0878-.9341-.2671-1.3671-.1812-.4329-.4483-.8249-.7841-1.1525-.3358-.3274-.7364-.5834-1.1733-.7528-.4388-.1692-.9062-.2482-1.3775-.2324-.5246-.0092-1.0474.0992-1.5263.3169-.4789.2179-.9024.5395-1.2401.9419-.3396.4024-.5819.8749-.7154,1.3834-.1316.5084-.1469,1.04-.0477,1.5556-.6009-1.0113-.8318-2.199-.6544-3.3614l-1.282.4109c-.227,2.8802,1.4671,6.6812,5.8436,6.6833M39.7543,12.6132c.4693-.0004.9272.1383,1.3183.3984.3911.26.6944.6296.8738,1.0623.1812.4327.2289.9089.1374,1.3685s-.3167.882-.6486,1.2136c-.3301.3318-.7536.5578-1.2134.6498-.4598.0921-.9367.0458-1.3717-.1328-.4331-.1786-.8051-.4817-1.0665-.8707-.2614-.3892-.4007-.8469-.4025-1.3153,0-.6288.2499-1.2321.6944-1.6772.4445-.4451,1.0493-.6956,1.6789-.6965"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 7.5665,
    y1: 63.9106,
    x2: 79.9029,
    y2: 63.9106,
    fill: "none",
    stroke: "#9c9f9f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0514,63.2207s-1.4902-.2873-3.5575-3.7895c-1.5836-2.6827-1.1494-5.3612-1.1494-5.3612,0,0,2.6623,2.1775,3.7921,4.9716.7343,1.8159.9147,4.1791.9147,4.1791Z",
    fill: "#abc894"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1609,63.2159s-1.9458-2.5753-4.4253-2.6513-3.3632.696-3.3632.696c0,0,1.9332,1.7109,3.7528,1.9468,2.1213.2749,4.0357.0086,4.0357.0086Z",
    fill: "#abc894"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7048,62.9342s2.5305,1.0979,4.4072.1118,2.2095-1.9319,2.2095-1.9319c0,0-2.1577-.4601-3.6106.1296-1.6938.6874-3.0061,1.6905-3.0061,1.6905Z",
    fill: "#abc894"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.981,63.2975s-.7897-2.8196,1.1748-4.6365,3.5542-1.5228,3.5542-1.5228c0,0,.0161,2.2561-.8959,3.6087-1.465,2.1728-3.8331,2.5506-3.8331,2.5506Z",
    fill: "#abc894"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0651,62.563s1.8929-2.4007,1.3538-4.6449c-.5391-2.2441-1.4668-2.8407-1.4668-2.8407,0,0-1.1002,2.1697-.8704,3.8623.2679,1.9733.9834,3.6233.9834,3.6233Z",
    fill: "#abc894"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826,64.8913c-.5408-2.0657-1.5318-3.2177-3.3789-3.2177-1.3785,0-2.0207.8808-2.4802,1.5318-.0202-.0004-.451-.8233-1.7616-.7276s-2.1439,1.0446-2.1717,2.4135h9.7925Z",
    fill: "#81ad76"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4363,64.8913c.0002-.0159.0012-.0316.0012-.0475,0-1.6947-1.9509-3.2468-3.3679-2.5574-.0766-1.4169-1.4434-2.0518-2.6669-2.0518-2.1782,0-3.028,1.7658-3.028,3.944,0,.2435.0232.4815.0655.7128h8.9961Z",
    fill: "#81ad76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6551,
    y: 27.1047,
    width: 12.6191,
    height: 1.0029,
    fill: "#ecac00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2461,
    y: 27.1188,
    width: 12.6061,
    height: 0.9983,
    fill: "#ecac00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiBasic);
export default __webpack_public_path__ + "static/media/pi_basic.c78914dce31ea41985b679362d414bae.svg";
export { ForwardRef as ReactComponent };